module.exports = __webpack_public_path__ + "img/37695-030.b0d24ea9.jpg";